var map = {
	"./stp00_accessory_cold@2x~watch.png": 794,
	"./stp00_accessory_rain@2x~watch.png": 6,
	"./stp00_accessory_sun@2x~watch.png": 266,
	"./stp00_accessory_windy@2x~watch.png": 977,
	"./stp00_advice_highuv@2x~watch.png": 531,
	"./stp00_advice_hot@2x~watch.png": 911,
	"./stp00_bottom_light@2x~watch.png": 403,
	"./stp00_bottom_medium@2x~watch.png": 670,
	"./stp00_filler_01@2x~watch.png": 281,
	"./stp00_filler_02@2x~watch.png": 864,
	"./stp00_filler_03@2x~watch.png": 459,
	"./stp00_jacket_heavy@2x~watch.png": 113,
	"./stp00_jacket_light@2x~watch.png": 390,
	"./stp00_jacket_medium@2x~watch.png": 329,
	"./stp00_shoe_light@2x~watch.png": 915,
	"./stp00_shoe_medium@2x~watch.png": 374,
	"./stp00_top_heavy@2x~watch.png": 570,
	"./stp00_top_light@2x~watch.png": 897,
	"./stp00_top_medium@2x~watch.png": 708,
	"./stp01_accessory_windy@2x~watch.png": 970,
	"./stp01_bottom_light@2x~watch.png": 26,
	"./stp01_top_heavy@2x~watch.png": 405,
	"./stp01_top_light@2x~watch.png": 42,
	"./stp02_shoe_medium@2x~watch.png": 280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 369;